

custom.loadMoreCards = (() => {

  const timeout = 500;
  const offsetRatio = 5;
  const offset = document.documentElement.clientHeight * offsetRatio;

  let inQueue = [];

  // Subscribe to events
  function on(evt=null,callback=null) {
      if(!evt || !callback || typeof callback !== 'function') return;
      actions[evt] = actions[evt] || [];
      actions[evt].push(callback);
  }

  // Trigger events
  function trigger(evt=null,payload={}) {
      if(!evt) return;
      actions[evt].forEach(fn => fn(payload));
  }

  /**
  * onTheBottom
  * Returns true if scrolling past the bottom of result container
  */
  function onTheBottom(containerId="") {
    const distance = $(`#${containerId}`).offset().top + document.getElementById(containerId).scrollHeight - document.documentElement.clientHeight + document.body.getBoundingClientRect().top;
    return (distance - offset) < 0;
  }

  function scrollHandler(resultId = "", loadMoreId = "") {
    if (onTheBottom(resultId) && !inQueue[loadMoreId]) {
      inQueue[loadMoreId] = true;
      const loadMoreTarget = document.getElementById(loadMoreId);
      if (loadMoreTarget != null && loadMoreTarget.offsetParent != null && !loadMoreTarget.disabled) {
        loadMoreTarget.click();
      }
    }
  }

  function enableLoadMore(loadMoreId = "load-more") {
    // inQueue = false;
    // inQueue[loadMoreId] = false
    setTimeout(() => { inQueue[loadMoreId] = false;}, timeout);
  }

  function init(resultId = "searchResults", loadMoreId = "load-more") {
    return $(`#${resultId}`).length > 0 && $(`#${loadMoreId}`).length > 0 ? window.addEventListener(
          "scroll",
          custom.utils.throttle(() => {
            scrollHandler(resultId, loadMoreId);
          }, 100),
          { passive: true }
        ) : false;
  };
  // Make public
  return {
    init,
    on,
    trigger,
    enableLoadMore
  }

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/load-more-cards.js